import { ofType, Epic } from "redux-observable";
import { catchError, map, merge, mergeMap, of, takeUntil } from "rxjs";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import {
    AuthActionType,
    IUserDetailsGetAction,
} from "../../auth/redux/auth.actions";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { getGlobals } from "../service/globals.api";
import {
    IGlobalsInitAction,
    IGlobalsGetAction,
    globalsInitAction,
    globalsSuccessAction,
    globalsErrorAction,
    GlobalsActionType,
    globalsGetAction,
} from "./globals.actions";

export const gloablsEpic: Epic<IAction, IAction, IRootState> = (action$) =>
    merge(
        action$.pipe(
            ofType<IUserDetailsGetAction, AuthActionType.USER_DETAILS_GET>(
                AuthActionType.USER_DETAILS_GET,
            ),
            mergeMap(() => of(globalsInitAction())),
        ),
        action$.pipe(
            ofType<IGlobalsInitAction, GlobalsActionType.GLOBALS_INIT>(
                GlobalsActionType.GLOBALS_INIT,
            ),
            mergeMap(() => of(globalsGetAction())),
        ),
        action$.pipe(
            ofType<IGlobalsGetAction, GlobalsActionType.GLOBALS_GET>(
                GlobalsActionType.GLOBALS_GET,
            ),
            mergeMap(() =>
                getGlobals(selectAuthTokens()).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                IGlobalsGetAction,
                                GlobalsActionType.GLOBALS_GET
                            >(GlobalsActionType.GLOBALS_GET),
                        ),
                    ),
                    map((result) => globalsSuccessAction(result)),
                    catchError((error: IErrorDto) =>
                        of(globalsErrorAction(error.message)),
                    ),
                ),
            ),
        ),
    );
